export default __webpack_public_path__ + "static/media/mango-madness.7f3b2965.jpeg";